/**
 * 상태 배지.
 *
 * 상태 문구는 서버가 내려준 라벨을 그대로 쓰고, 색만 화면이 정한다 —
 * 대회 · 신청 · 선수 상태가 화면마다 다른 색으로 보이지 않게 여기 한 곳에 모은다.
 * 표에 없는 라벨은 회색(기본 `.app-badge`)으로 둔다.
 */
const TONE_CLASS_BY_LABEL: Record<string, string> = {
  "접수 중": "app-badge-brand",
  "진행 중": "app-badge-brand",
  "접수 완료": "app-badge-green",
  "승인 완료": "app-badge-green",
  확정: "app-badge-green",
  "편성 완료": "app-badge-amber",
  "승인 대기": "app-badge-amber",
  반려: "app-badge-red",
  취소: "app-badge-red",
  "신청 취소": "app-badge-red",
}

type StatusBadgeTone = "brand" | "green" | "amber" | "red"

interface StatusBadgeProps {
  label: string
  /** 라벨만으로 색이 정해지지 않는 문구(「4/5 승인」처럼 값이 도는 집계)에 직접 지정한다 */
  tone?: StatusBadgeTone
  className?: string
}

export default function StatusBadge({
  label,
  tone,
  className = "",
}: Readonly<StatusBadgeProps>) {
  const toneClass = tone
    ? `app-badge-${tone}`
    : (TONE_CLASS_BY_LABEL[label] ?? "")

  return (
    <span className={`app-badge ${toneClass} ${className}`.trim()}>
      {label}
    </span>
  )
}
